import { FetchHelper } from '../stores/authTokens/FetchHelper';
import type { BlogPost } from '@portal/types/nexudus/blog';

const fetchHelper = new FetchHelper();

export type BlogCategory = { Id: number; Title: string };

export type BlogPostsPage = {
  BlogPosts: BlogPost[];
  Categories: BlogCategory[];
  Page?: number;
  Top?: number;
};

export type BlogPostsParams = {
  page: number;
  size: number;
  categoryId: number | null;
  query: string;
};

async function getJson(nexudusToken: string, host: string, path: string) {
  const apiUrl = `https://${host.split(':')[0]}:443`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (nexudusToken) {
    headers.Authorization = `Bearer ${nexudusToken}`;
  }

  const result = await fetchHelper.fetch(`${apiUrl}/en${path}`, {
    method: 'GET',
    headers,
  });
  return result.json();
}

export async function fetchBannerBlogPosts(
  nexudusToken: string,
  host: string,
): Promise<BlogPost[]> {
  return ((await getJson(nexudusToken, host, '/?_resource=BannerBlogPosts')) ??
    []) as BlogPost[];
}

export async function fetchBlogPostsPage(
  nexudusToken: string,
  host: string,
  { page, size, categoryId, query }: BlogPostsParams,
): Promise<BlogPostsPage> {
  // Same endpoints as agent.js, but the search text is encoded so & or # can't break the URL
  const base =
    categoryId === null ? '/blog' : `/blog/index/${categoryId}/category`;
  const search = query ? `&query=${encodeURIComponent(query)}` : '';
  const body = (await getJson(
    nexudusToken,
    host,
    `${base}?size=${size}&page=${page}&_depth=4${search}`,
  )) as Partial<BlogPostsPage> | null;

  return {
    ...body,
    BlogPosts: body?.BlogPosts ?? [],
    Categories: body?.Categories ?? [],
  };
}
